import { Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';

import { TableBasic } from '../../components/TableBasic';
import { TitlePage } from '../../components/TitlePage';
import { EstimateFilter } from './components/EstimateFilter';
import { urlDatatableEstimate } from '../../helpers';
import useFetch from '../../hooks/useFetch';

export const EstimateScreen = ({ status }) => {

  const [filterArray, setFilterArray] = useState([]);
  const [copyArray, setCopyArray] = useState([]);
  const { data } = useFetch(urlDatatableEstimate, 'GET', {});

  useEffect(() => {
    if (status) {
      setFilterArray(data?.filter(el => el.status === status));
      setCopyArray(data?.filter(el => el.status === status))
    } else {
      setFilterArray(data)
      setCopyArray(data)
    }
  }, [status, data])

  return (
    <Stack width='100%' alignItems='center' mt='2rem'>
      <Stack width='95%' alignItems='center'>
        <TitlePage title={title[status] || 'Presupuestos'} subtitle={subtitle} buttonTitle={buttonTitle} />
        {filterArray
          ? <EstimateFilter status={{ status }} setFilterArray={setFilterArray} copyArray={copyArray} />
          : <CircularProgress sx={{ marginBottom: '5rem', marginTop: '5rem' }} />
        }
        {
          (data && filterArray)
            ? <TableBasic setCopyArray={setCopyArray} tableTitle={tableTitle} rows={filterArray} colNames={colNames} values={values} setFilterArray={setFilterArray}/>
            : <CircularProgress />
        }
      </Stack>
    </Stack>
  )
}

const colNames = ['Nº presupuesto', 'Cliente', 'Llamar el:', 'Contacto', 'Teléfono de contacto', 'Estado', ''];

const values = ['id', 'ID', 'client', 'dateCall', 'contact', 'telContact', 'status'];

const subtitle = "Consulte datos de los presupuestos";
const buttonTitle = "Nuevo Presupuesto";
const title = {
  'Provisional': 'Presupuestos provisionales',
  'Aceptado': 'Presupuestos aceptados',
  'Definitivo': 'Obras'
}
const tableTitle = "estimate";